import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const detailedServices = [
  {
    title: "Strategy",
    items: ["Corporate Strategy", "Business Unit Strategy", "Digital Strategy", "Social Impact"]
  },
  {
    title: "Operations",
    items: ["Supply Chain", "Procurement", "Manufacturing", "Zero-Based Budgeting"]
  },
  {
    title: "Digital",
    items: ["AI & Data", "Enterprise Technology", "Digital Growth", "Cybersecurity"]
  },
  {
    title: "Transactions",
    items: ["Mergers & Acquisitions", "Divestitures", "Private Equity", "Due Diligence"]
  }
];

export default function ServicesPage() {
  return (
    <div className="pt-32 pb-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="max-w-3xl mb-16">
          <h1 className="text-5xl font-serif text-slate-900 mb-6">Our Capabilities</h1>
          <p className="text-xl text-slate-600 font-light leading-relaxed">
            We provide specialized expertise across every major industry and function to help our clients achieve sustainable competitive advantage.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12">
          {detailedServices.map((group, idx) => (
            <motion.div 
              key={idx}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: idx * 0.1 }}
            >
              <h3 className="text-amber-600 font-bold uppercase tracking-widest text-sm mb-6 pb-2 border-b border-amber-600/20">
                {group.title}
              </h3>
              <ul className="space-y-4">
                {group.items.map((item, i) => (
                  <li key={i} className="group flex items-center justify-between text-slate-900 font-medium hover:text-amber-600 transition-colors cursor-pointer">
                    {item}
                    <SafeIcon icon={FiIcons.FiChevronRight} className="opacity-0 group-hover:opacity-100 transition-opacity" />
                  </li>
                ))}
              </ul>
            </motion.div>
          ))}
        </div>

        <div className="mt-24 p-12 bg-slate-50 border border-slate-100">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-3xl font-serif mb-4">Industrial Specialization</h2>
              <p className="text-slate-600 mb-8">
                Our consultants bring deep sector expertise, ensuring that our strategic recommendations are not only theoretically sound but practically executable.
              </p>
              <div className="grid grid-cols-2 gap-4 text-sm font-semibold text-slate-700">
                {['Consumer Goods', 'Financial Services', 'Healthcare', 'Energy & Utilities', 'Industrial', 'Technology'].map(industry => (
                  <div key={industry} className="flex items-center gap-2">
                    <div className="w-1.5 h-1.5 bg-amber-600 rounded-full"></div>
                    {industry}
                  </div>
                ))}
              </div>
            </div>
            <img 
              src="https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&q=80&w=800" 
              className="w-full h-64 object-cover shadow-lg"
              alt="Industry"
            />
          </div>
        </div>
      </div>
    </div>
  );
}